module.exports = __webpack_public_path__ + "static/media/js.4c046aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/js.png
// module id = 1496
// module chunks = 0